import { usePostTimesheetSaveSettled } from '@sit/client-shared';
import { track } from '@web/analytics/analyticsClient';
import trackEvents from '@web/analytics/trackEvents';
import { setSyncStatus } from '@web/services/timesheet-sync-status';
import { useCallback } from 'react';

export const useTimesheetSaveSettled = () => {
  const onSettle = usePostTimesheetSaveSettled();
  return useCallback(
    (timesheetId: string, isSuccess: boolean) => {
      onSettle(timesheetId);
      if (isSuccess) {
        setSyncStatus({ timesheetId, synced: true });
        track(trackEvents.TIMESHEET_SAVE);
      }
    },
    [onSettle],
  );
};
